export const ADMIN_PAGE_ROLES = [
  'ROLE_SYSTEM',
  'ROLE_ADMIN',
  'ROLE_EMP',
  'ROLE_EMP_FINANCE',
  'ROLE_PARTNER',
  'ROLE_DEALER',
  'ROLE_EMP_ADV',
];
